module.exports = __webpack_public_path__ + "img/20201112_benovelty_onedegree_fiberapi.d2e6ccb0.jpg";